import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Tabs from '../../../../common/base/Tabs';
import CopyableField from '../../../../common/CopyableField';
import { CLIOnboardingContext } from '../GuidedCLIOnboarding';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Badge from '../../../../common/base/Badge';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import Link from '../../../../common/base/Link';
interface Props {
  context: CLIOnboardingContext;
  mutateContext: (input: any) => void;
  nextStep: () => void;
  is_current_step: boolean;
}
const platforms = {
  npm: {
    label: 'NPM',
    command: 'npm install hookdeck-cli -g'
  },
  yarn: {
    label: 'Yarn',
    command: 'yarn global add hookdeck-cli'
  },
  homebrew: {
    label: 'Homebrew',
    command: 'brew install hookdeck'
  },
  windows: {
    label: 'Windows',
    commands: ['scoop bucket add hookdeck https://github.com/hookdeck/scoop-hookdeck-cli.git', 'scoop install hookdeck']
  },
  linux: {
    label: 'Linux',
    commands: [<Div key="download" flex={{
      align: 'center',
      gap: 1
    }}>
        <Text base>Download the latest release’s</Text>
        <Link href="https://github.com/hookdeck/hookdeck-cli/releases/latest" target="_blank" onClick={e => e.stopPropagation()}>
          <Text base semi>
            tar.gz file
          </Text>
        </Link>
      </Div>, 'tar -xvf hookdeck_X.X.X_linux_x86_64.tar.gz', './hookdeck']
  }
};
type PlatformKey = keyof typeof platforms;
const InstallHookdeckCLI: React.FC<Props> = () => {
  const $ = _c(10);
  const [active_tab, setActiveTab] = useState("npm");
  const current_platform = platforms[active_tab];
  const commands = "commands" in current_platform ? current_platform.commands : current_platform.command;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.entries(platforms).map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = key_0 => setActiveTab(key_0 as PlatformKey);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      t: 2,
      x: 3
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== active_tab) {
    t3 = <StyledCardSection><Tabs tabs={t0} active_tab={active_tab} onTabSelected={t1} compact={true} border={false} m={t2} /></StyledCardSection>;
    $[3] = active_tab;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== commands) {
    t4 = <StyledCardSection>{Array.isArray(commands) ? <Div p={2} flex={{
        direction: "column",
        gap: 2
      }}>{commands.map(_temp2)}</Div> : <CopyableField borderless={true} m={0} p={{
        x: 3,
        y: 3
      }} value={commands} mono={true} variant="command_list" />}</StyledCardSection>;
    $[5] = commands;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <StyledCard overflow_hidden={true}>{t3}{t4}</StyledCard>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default InstallHookdeckCLI;
function _temp(t0) {
  const [key, platform] = t0;
  return {
    key,
    label: platform.label
  };
}
function _temp2(command, i) {
  return <CopyableField key={command.toString()} m={0} p={{
    x: 3,
    y: 3
  }} value={command.toString()} wrap={true} variant="command_list" valueElement={<Div flex={{
    align: "center",
    gap: 2
  }}><Badge neutral={true} style={{
      flexShrink: 0
    }}>{i + 1}</Badge><Text mono={true} text_wrap={false} word_break="break-all" white_space="pre-wrap" align="left" style={{
      minWidth: 0
    }} title={command.toString()}>{command}</Text></Div>} mono={true} />;
}